import { jwtDecode } from "jwt-decode";
import type { IJwtPayload } from "../types/auth";

export const isTokenValid = (token: string | null): boolean => {
  if (!token) return false; // Explicitly handle null/undefined tokens
  try {
    const decoded = jwtDecode<IJwtPayload>(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp ? decoded.exp > currentTime : false; // Return false if `exp` is missing
  } catch {
    return false; // Catch decoding errors
  }
};

export const getTokenPayload = (token: string): IJwtPayload | null => {
  try {
    return jwtDecode<IJwtPayload>(token);
  } catch {
    return null;
  }
};
